/* eslint-disable react/prop-types */
import React from "react"

import { DatePicker } from "@nextui-org/date-picker";

export const SelectorCalendarIcon = () => {
  return (
    <svg height="1.5em" viewBox="0 0 24 24" width="1.5em">
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      >
        <path d="M8 2v4m8-4v4" />
        <rect height="18" rx="2" width="18" x="3" y="4" />
        <path d="M3 10h18" />
      </g>
    </svg>
  );
};

const CustomDateInput = ({ label, className, value, isDisabled }) => {
  return (
    <div
      className={
        isDisabled
          ? "[&_*]:!border-b-0 [&_*]:!border-none [&_*]:!shadow-none "
          : ""
      }
    >
      <DatePicker
        label={label}
        value={value}
        className={className}
        variant="underlined"
        isDisabled={isDisabled}
        selectorIcon={<SelectorCalendarIcon />}
        selectorButtonProps={{
          placement: "start",
        }}
        classNames={{
          inputWrapper: [
            "data-[hover=true]:bg-transparent",
            isDisabled && [
              "!border-none",
              "bg-transparent",
              "!shadow-none",
              "!border-b-0",
            ],
          ],
          base: ["data-[disabled=true]:opacity-100"],
          trigger: [isDisabled && "!border-none"],
          value: [isDisabled && "!border-none"],
          label: isDisabled && "opacity-50",
          selectorButton: "order-first",
        }}
      />
    </div>
  );
};

export default CustomDateInput;
